import { render, staticRenderFns } from "./ResultatBac.vue?vue&type=template&id=47c51a58"
import script from "./ResultatBac.vue?vue&type=script&lang=js"
export * from "./ResultatBac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports